import { NullableClassName } from '@squareup/dex-types-shared-ui';
import { Paragraph20 } from '@squareup/dex-ui-shared-base';
import { breakHtmlForUnderscoreReact } from '@squareup/dex-utils-text';
import React, { FC } from 'react';

interface Props {
  name: string;
}

const ApiReferenceFieldName: FC<Props & NullableClassName> = ({
  name,
  className,
}) => {
  return (
    <Paragraph20 className={className} weight="medium">
      {breakHtmlForUnderscoreReact(name)}
    </Paragraph20>
  );
};

export { ApiReferenceFieldName };
